const initBlogFiltros = () => {
    const blogCategorias = document.querySelector(".blog__categories");
    const blogPosts = document.querySelector(".blog__most-popular");

    if (!blogCategorias || !blogPosts) return;

    if (window.innerWidth < 960) {
        blogCategorias.addEventListener("click", () => {
            blogCategorias.classList.toggle("active");
        });

        blogPosts.addEventListener("click", () => {
            blogPosts.classList.toggle("active");
        });
    }
}

export default initBlogFiltros;